import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import enUS from "./locales/en-US.json"
import frCA from "./locales/fr-CA.json"

// Storage key for persisting language preference
const LANGUAGE_STORAGE_KEY = "reporting-manager-language"

// Get initial language from localStorage or browser
function getInitialLanguage(): string {
  // Check localStorage first
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
  if (stored && (stored === "en-US" || stored === "fr-CA")) {
    return stored
  }

  // Fall back to browser language
  const browserLang = navigator.language
  if (browserLang.startsWith("fr")) {
    return "fr-CA"
  }

  return "en-US"
}

i18n.use(initReactI18next).init({
  resources: {
    "en-US": { translation: enUS },
    "fr-CA": { translation: frCA },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en-US",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
})

// Persist language changes to localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng)
})

export default i18n

// Export available languages for UI
export const availableLanguages = [
  { code: "en-US", name: "English (US)" },
  { code: "fr-CA", name: "Français (Canada)" },
]

// Helper to change language
export function changeLanguage(lng: string): void {
  i18n.changeLanguage(lng)
}
